export default "__VITE_ASSET__BZLoZN2K__"